import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { Store } from '@ngxs/store';
import { RoleAction, RolePermissionSubject } from '@wilson/interfaces';
import {
  CreateNewViaDragAndDropService,
  DragAndDropModeService,
} from '@wilson/shift-timeline/services';
import { ShiftTimelineSettingsState } from '@wilson/shift-timeline/state';

@Component({
  selector: 'wilson-new-activity-quick-creation-card',
  templateUrl: './new-activity-quick-creation-card.component.html',
  styleUrls: ['./new-activity-quick-creation-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NewActivityQuickCreationCardComponent {
  private store = inject(Store);
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  readonly createNewViaDragAndDropService = inject(
    CreateNewViaDragAndDropService,
  );

  @Input() isQuickCreationCardOpen = true;
  @Input() disabled = false;

  areActivitiesVisible$ = this.store.select(
    ShiftTimelineSettingsState.areActivitiesVisible,
  );
  RoleAction = RoleAction;
  RolePermissionSubject = RolePermissionSubject;
  can = inject(AbilityServiceSignal).can;

  startDrag(): void {
    this.createNewViaDragAndDropService.setNewActivityShiftDropZone(true);
    this.dragAndDropModeService.setDisplayTimeVisible(false);
    this.dragAndDropModeService.setDraggingItemId(
      CreateNewViaDragAndDropService.MOCK_SHIFT_ID,
    );
  }

  dragEnd(): void {
    this.createNewViaDragAndDropService.setNewActivityShiftDropZone(false);
    this.dragAndDropModeService.setDraggingItemId(null);
  }
}
